import { useQuery } from "@tanstack/react-query";
import { PatientScreenerAnswerControllerApi } from "../../../services";
import { getConfigObject } from "../../../utils/utils";

export const FORMS_AND_ASSESSMENTS_BY_APPOINTMENT_QUERY_KEY =
  "forms-and-assessments-by-appointment";

interface Props {
  appointmentUuid: string;
  xTENANTID?: string;
}

export const useGetFormsAndAssessmentsByAppointment = (props: Props) => {
  const { appointmentUuid, xTENANTID } = props;

  return useQuery({
    queryKey: [
      FORMS_AND_ASSESSMENTS_BY_APPOINTMENT_QUERY_KEY,
      appointmentUuid,
      xTENANTID,
    ],
    queryFn: async () =>
      await new PatientScreenerAnswerControllerApi(
        getConfigObject()
      ).getFormsAndAssessmentsByAppointment(
        appointmentUuid,
        undefined,
        undefined,
        undefined,
        undefined,
        xTENANTID
      ),
    enabled: !!appointmentUuid,
  });
};
